import { render, staticRenderFns } from "./MyExperience.vue?vue&type=template&id=d0966f16&scoped=true&"
import script from "./MyExperience.vue?vue&type=script&lang=js&"
export * from "./MyExperience.vue?vue&type=script&lang=js&"
import style0 from "./MyExperience.vue?vue&type=style&index=0&id=d0966f16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0966f16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
